// extracted by mini-css-extract-plugin
module.exports = {"title":"_10904","qrcode":"_2200"};